// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5974":"css/app.6679","9287":"css/admin-app.6679"}[chunkId] + ".css";
};